/**
 * GenderLink Component
 *
 * Text link style gender selection for Hero Search dropdown
 * Displays as simple text links with underline on active/hover
 * Based on Figma: Taxonomy Hover Link (Node: 1785:9845)
 *
 * Typography (Figma specs):
 * - Font: Inter
 * - Size: 12.25px
 * - Line height: 17.5px
 * - Letter spacing: -0.0179px
 * - Active: Medium weight, black text (#000000)
 * - Inactive: Regular weight, gray text (#99a1af)
 *
 * States:
 * - Default: Gray text, no underline
 * - Active/Selected: Black text with underline
 * - Hover: Show underline
 */
"use client";

import { useState } from "react";

interface GenderLinkProps {
  text: string;
  isSelected: boolean;
  onClick: () => void;
}

export function GenderLink({ text, isSelected, onClick }: GenderLinkProps) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="relative flex cursor-pointer flex-col items-start border-none bg-transparent p-0"
      style={{
        fontFamily: "Inter, sans-serif",
        fontSize: "12.25px",
        fontWeight: isSelected ? 500 : 400,
        lineHeight: "17.5px",
        letterSpacing: "-0.0179px",
        color: isSelected ? "#000000" : "#99a1af",
        textAlign: "left",
      }}
    >
      {text}
      {/* Underline - visible when selected or hovered */}
      <div
        style={{
          position: "absolute",
          bottom: "-1.739px",
          left: 0,
          width: "100%",
          height: "1.739px",
          backgroundColor: isSelected ? "#000000" : "#99a1af",
          opacity: isSelected || isHovered ? 1 : 0,
          transition: "opacity 0.2s ease",
        }}
      />
    </button>
  );
}
